import { render, staticRenderFns } from "./AuthSetPassword.vue?vue&type=template&id=008b3cbc&"
import script from "./AuthSetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports